/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useEffect, useState } from 'react';
import { Col, Modal } from 'react-bootstrap';
import { RoleComp } from '../components/SwitchRole';
import { EventBusModule } from '@vlinder-web/event-bus-module-react';
import { useSMSwitchRoles } from '../machines/switchRoles';
import { Loader } from '@/components';
import { vappContainer } from '@/application';
import { SwitchRolesPageService } from '../services';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export const ROLES_MODAL_OPEN = 'RolesModal:Open';
export const ROLES_MODAL_CLOSE = 'RolesModal:Close';
const getSrv = () => {
  return vappContainer.get<SwitchRolesPageService>(
    SwitchRolesPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const eventBus = EventBusModule?.getInstance()?.getEventBus();
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const storageSrv = StorageModule.getInstance();
  const [role, setRole] = useState('');
  const [org, setOrg] = useState('');
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const { switchRolesMachine, switchRolesState, switchRolesSend } =
    useSMSwitchRoles({});
  const _localData = storageSrv.get('userProfile', 'local');
  const _sessionData = storageSrv.get('userProfile', 'session');
  const userData = _sessionData ?? _localData;
  useEffect(() => {
    _subscribe();
    return _unsubscribe;
  }, []);

  const _subscribe = () => {
    eventBus.on(ROLES_MODAL_OPEN, _onModalOpen);
  };

  const _unsubscribe = () => {
    eventBus.off(ROLES_MODAL_CLOSE, _onModalClose);
  };

  const _onModalOpen = (props: any) => {
    setVisible(true);
    switchRolesSend('START', {});
  };

  const _onModalClose = () => {
    setVisible(false);
  };

  const onRoleSelect = (role: any) => {
    const { roleId, name, org } = role;
    setRole(name);
    setOrg(org);
    console.log('onrole->');
    switchRolesSend('GET_ACCESS_TOKEN', {
      name,
      payload: {
        roleId,
        org,
      },
    });
  };

  useEffect(() => {
    if (
      switchRolesState?.matches('GET_USER_ROLES_FAILED') &&
      switchRolesState?.event?.data?.value
    ) {
      setVisible(false);
      setTimeout(() => {
        toast.error(
          switchRolesState?.event?.data?.value ??
            staticPageContentConfig?.error?.getUsersRolesError?.title
        );
      }, 500);
    }
    if (
      switchRolesState?.matches('SIGN_IN_USER_FAILED') &&
      switchRolesState?.event?.data?.value
    ) {
      setVisible(false);
      setTimeout(() => {
        toast.error(
          switchRolesState?.event?.data?.value ??
            staticPageContentConfig?.error?.getUsersRolesError?.title
        );
      }, 500);
    }
    if (switchRolesState?.matches('SIGN_IN_USER_SUCCESS')) {
      const content = switchRolesState?.event?.data?.value;
      const _localData = storageSrv.get('userProfile', 'local');
      const _sessionData = storageSrv.get('userProfile', 'session');
      const userData = _sessionData ?? _localData;
      console.log(userData);
      storageSrv.set(
        'userProfile',
        {
          ...userData,
          currentRole: role,
          currentOrg: org,
          orgRole: userData?.orgRoles[0]?.org?.orgRole,
          accessToken: content?.accessToken,
        },
        'session'
      );
      const data = _localData ?? _sessionData;
      console.log(`print 5:`, switchRolesState?.event?.data?.value);

      if (content?.accessToken) {
        setVisible(false);
        console.log(content, role);
        if (userData?.orgRoles[0]?.org?.orgRole === 'ISSUER') {
          setTimeout(() => {
            window.open('/profile/my-profile', '_self');
            navigate('/profile/my-profile', { replace: true });
          }, 1000);
        } else if (role === 'owner') {
          setTimeout(() => {
            window.open('/profile/organization-profile', '_self');
            navigate('/profile/organization-profile', { replace: true });
          }, 1000);
        } else if (role === 'agent') {
          setTimeout(() => {
            window.open('/profile/organization-profile', '_self');
            navigate('/profile/organization-profile', { replace: true });
          }, 1000);
        } else if (role === 'admin') {
          setTimeout(() => {
            window.open('/profile/organization-profile', '_self');
            navigate('/profile/organization-profile', { replace: true });
          }, 1000);
        } else if (role === 'prospective_employee') {
          window.open('/profile/my-profile', '_self');
          navigate('/profile/my-profile', { replace: true });
        } else {
          setTimeout(() => {
            window.open('/profile/my-profile', '_self');
            navigate('/profile/my-profile', { replace: true });
          }, 1000);
        }
      }
    }
  }, [switchRolesState]);

  const onAddRole = () => {
    window.open(`/add-role`, '_self');
  };

  console.log('massna->', visible);
  const _renderLoading = () => {
    if (switchRolesState?.matches('GET_USER_ROLES')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.userRoles || {})}
        />
      );
    }
    if (switchRolesState?.matches('GET_ACCESS_TOKEN')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.getAccessToken || {})}
        />
      );
    }
    if (switchRolesState?.matches('SIGN_IN_USER_SUCCESS')) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.getAccessToken || {})}
        />
      );
    }
  };

  console.log('userrole->', switchRolesState?.value);
  return (
    <>
      {_renderLoading()}
      <Modal
        show={switchRolesState?.matches('GET_USER_ROLES_SUCCESS') && visible}
        onHide={() => setVisible(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Switch Entity/Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col md={12} xs={12}>
            <RoleComp
              {...switchRolesState?.event?.data?.value}
              currentRole={userData?.currentRole}
              currentOrg={userData?.currentOrg}
              onRoleSelect={onRoleSelect}
              onAddRole={onAddRole}
            />
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};
